import {
  Elements,
  ElementsConsumer,
  ExpressCheckoutElement,
} from '@stripe/react-stripe-js';
import React, { useMemo } from 'react';
import { createUseStyles } from 'react-jss';
import { layoutDefaults } from '../../utils/layout-defaults';
import { WalletType } from '../../utils/manager/card-manager';
import { PaymentDetails } from './payment-details';

function PaymentWalletModalBody({
  wallet,
  payment,
  spot,
  menuInfo,
  feature,
  elements,
  stripe,
  cancelling,
  onReady,
  onError,
  onClick,
  onConfirm,
  onCancel,
}) {
  // const promiseRef = useRef();
  const classes = useStyles({ cancelling });

  // useEffect(() => {
  //   if (stripe != null && elements != null) {
  //     // onLoad?.call(this, { stripe, elements });
  //     onLoad?.call(this, { charge });
  //   }
  // }, [stripe, elements, onLoad]);

  // const charge = async () => {
  //   promiseRef.current = new Promise((resolve) => {
  //     promiseResolverRef.current = resolve;
  //   });

  //   await formRef.current.requestSubmit();
  //   await Promise.all([promiseRef.current]);

  //   console.log('charge charge charge charge charge charge');
  // };

  const setError = (error) => {
    onError?.call(this, error);
  };

  const handleOnConfirm = async () => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    // setError(null);s
    // event.preventDefault();

    // if (!stripe || !elements) {
    //   // Stripe.js hasn't yet loaded.
    //   // Make sure to disable form submission until Stripe.js has loaded.
    //   return;
    // }

    const result = await stripe.confirmPayment({
      // `Elements` instance that was used to create the Payment Element
      elements,
      redirect: 'if_required',
      confirmParams: {
        return_url: 'https://example.com/order/123/complete',
      },
    });

    if (result.error) {
      // This point will only be reached if there is an immediate error when
      // confirming the payment. Show error to your customer (for example, payment
      // details incomplete)

      // result.error.handleGeneric = false;
      setError(result.error);
    } else {
      // Your customer will be redirected to your `return_url`. For some payment
      // methods like iDEAL, your customer will be redirected to an intermediate
      // site first to authorize the payment, then redirected to the `return_url`.
      onConfirm.call(this, result);
    }

    // promiseResolverRef.current();
  };

  return (
    <div className={classes.container}>
      {/* <div className={classes.elementContainer}>
        <div className={classes.element}> */}
      <PaymentDetails
        style={classes.total}
        // backgroundColor={tinycolor(layoutDefaults.cardColor)
        //   .darken(30)
        //   .toHex8String()}
        payment={payment}
        spot={spot}
        menuInfo={menuInfo}
        feature={feature}
        // stripe={stripe}
        elements={elements}
      />
      {/* <form ref={formRef} onSubmit={handleSubmit}> */}
      {/* {!cancelling && ( */}
      <div className={classes.element}>
        <ExpressCheckoutElement
          options={{
            buttonType: {
              applePay: 'plain',
              googlePay: 'plain',
            },
            buttonTheme: {
              applePay: 'white-outline',
              googlePay: 'white',
            },
            buttonHeight: 44,
            paymentMethods: {
              amazonPay: 'never',
              link: 'never',
              paypal: 'never',
              applePay: wallet === WalletType.APPLE_PAY ? 'always' : 'never',
              googlePay: wallet === WalletType.GOOGLE_PAY ? 'always' : 'never',
            },
          }}
          onReady={onReady}
          onLoadError={onError}
          onConfirm={handleOnConfirm}
          onCancel={onCancel}
          onClick={onClick}
        />
      </div>
      {/* )} */}
      {/* </form> */}
      {/* </div>
      </div> */}
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    // position: 'relative',
    // display: 'flex',
    // flex: 1,
    // flexGrow: 1,
    // minHeight: 54,
    // border: '1px solid red',
    marginBottom: layoutDefaults.verticalMargin,
  },
  elementContainer: {
    position: 'relative',
  },
  element: {
    position: 'absolute',
    // zIndex: 10,
    // elevation: 10,
    width: '100%',
    // visibility: ({ cancelling }) => (cancelling ? 'hidden' : 'visible'),
    // height: 0,
    // opacity: 1,
    opacity: 0.0000001,
    bottom: 84,
    left: 0,
    // border: '1px solid red',
  },
  total: {
    // marginTop: -layoutDefaults.verticalMargin,
    // paddingTop: layoutDefaults.verticalMargin,
    // marginBottom: layoutDefaults.smallVerticalMargin,
  },
});

function StripeElementsConsumer(props) {
  return (
    <ElementsConsumer>
      {({ stripe, elements }) => (
        <PaymentWalletModalBody
          {...props}
          stripe={stripe}
          elements={elements}
        />
      )}
    </ElementsConsumer>
  );
}

function StripeBodyWrapper(props) {
  // const {loadStripeClientIdFromRemote} = useTempAPI();
  const { clientSecret, menuLayout, stripePromise } = props;
  const font = menuLayout?.text?.default_font;

  // useEffect(() => {
  //   console.log('clientSecret');
  //   console.log(clientSecret);
  // }, [clientSecret]);

  // const [clientId, setClientId] = useState();

  // useEffect(() => {
  //   async function init() {
  //     const response = await loadStripeClientIdFromRemote();
  //     setClientId(response.data);
  //   }

  //   init();
  // }, []);

  console.log('layout');
  console.log(menuLayout?.text?.default_font);

  // const stripePromise = useMemo(
  //   () => loadStripe(config?.stripe?.api_key),
  //   [config?.stripe]
  // );

  const appearance = useMemo(
    () => ({
      theme: 'stripe',
      variables: {
        fontSizeBase: layoutDefaults.smallFontSize,
        // fontWeightNormal: 100,
        // colorText: layoutDefaults.textPlaceholderColor,
        // colorTextSecondary: layoutDefaults.textPlaceholderColor,
        // colorTextSecondary: 'red',
        // colorPrimaryText: layoutDefaults.primaryColor,
        // colorPrimaryText: 'red',
        // colorTextSecondary: 'red',
        // colorPrimaryText: 'red',
        colorText: layoutDefaults.primaryColor,
        // colorText: layoutDefaults.buttonBorder,
        colorTextPlaceholder: layoutDefaults.buttonBorder,
        colorDanger: layoutDefaults.destructiveColor,
        fontFamily: menuLayout?.text?.default_font,
        // fontWeight: 100,
      },
    }),
    [menuLayout]
  );

  const options = useMemo(
    () => ({
      loader: 'always',
      clientSecret,
      fonts: [
        {
          cssSrc: `https://fonts.googleapis.com/css?family=${font}:200,400,500,600`,
        },
      ],
      appearance,
    }),
    [appearance, clientSecret]
  );

  if (!clientSecret) {
    return null;
  }

  return (
    <Elements stripe={stripePromise} options={options}>
      <StripeElementsConsumer {...props} />
    </Elements>
  );
}

export { StripeBodyWrapper as PaymentWalletModalBody };
